<template>
  <div class="class-info">
    <TopBar :type="2" :pageTitle="'我的班级'" />
    <!-- <p class="class-title">{{ classInfo.name }}</p> -->
    <div class="line"></div>
    <div class="class_main">
      <div class="class_cont">
        <div class="info_show">
          <p class="title_name">{{ classData.name }}</p>
          <div class="deep_pros">
            <div class="left">
              <p class="label">课程进度{{ classData.course_rate }}%</p>
              <div class="pross_fir">
                <p :style="{ width: classData.course_rate + '%' }"></p>
              </div>
            </div>
            <div class="right">有效期至{{ classData.end_time }}</div>
          </div>
          <template v-if="isWeixin">
            <div v-if="typeIndex == 1 && classData.cert_url && siteInfo.is_open_class_cert == 1" class="cert_cont"><a
                @click="bookImgState = true">证书下载</a> </div>
            <div v-if="typeIndex == 2 && classData.cert_url" class="cert_cont"><a @click="bookImgState = true">证书下载</a>
            </div>
          </template>
          <template v-else>
            <div v-if="typeIndex == 1 && classData.cert_url && siteInfo.is_open_class_cert == 1" class="cert_cont"><a
                :href="classData.cert_url">证书下载</a> </div>
            <div v-if="typeIndex == 2 && classData.cert_url" class="cert_cont"><a :href="classData.cert_url">证书下载</a>
            </div>
          </template>

        </div>
        <div class="exam_info">
          <p class="text">考试情况</p>
          <div class="right_text">
            <p class="text1">{{ classData.exam_success }}项已通过</p>
            <p class="text2">{{ classData.exam_fail }}项未通过</p>
          </div>
        </div>
      </div>
      <ul class="class-list">
        <li class="title">班级课程</li>
        <li class="class-list-info" v-for="item in classCourse" :key="item.id">
          <router-link :to="'/recordedInfo/' + item.id">
            <img class="info-img" :src="item.image" alt="" />
            <div class="info-content">
              <div class="info-title vertical-ellipsis">{{ item.name }}</div>
              <div class="progress">
                <div class="num">{{ item.rate }}</div>
                <div class="progress-bg">
                  <div class="progress-line" :style="{ width: item.rate }"></div>
                </div>
              </div>
            </div>
          </router-link>
        </li>
        <li class="no-data" v-if="classCourse && classCourse.length == 0">
          班级内还没有课程
        </li>
      </ul>
      <ul class="class-list">
        <li class="title">文本课程</li>
        <li class="class-list-info" v-for="item in textCourseList" :key="item.id" @click="goTextDetail(item.id)">
          <!-- <router-link :to="'/textCourse/detai?id=' + item.id"> -->
          <img class="info-img" :src="item.image" alt="" />
          <div class="info-content">
            <div class="info-title vertical-ellipsis">{{ item.title }}</div>

          </div>
          <!-- </router-link> -->
        </li>
        <li class="no-data" v-if="textCourseList && textCourseList.length == 0">
          班级内还没有课程
        </li>
      </ul>
    </div>
    <ul class="test-list">
      <li class="title">班级考试</li>
      <li class="test-info" v-if="classInfo && classInfo.id == '302' && typeIndex == '1'">
        <div class="test-title vertical-ellipsis">培训心得</div>
        <div class="btns">
          <router-link :to="'/textarea'" class="button blue">去考试</router-link>
        </div>
      </li>
      <li class="test-info" v-for="item in classExam" :key="item.id">
        <div class="exam-card-head">
          <span class="exam-badge">考试</span>
          <div class="test-title vertical-ellipsis">{{ item.exam_name }}</div>
        </div>
        <div class="test-date">
          <div class="test-date-text">
            <span>{{ item.start_time }}</span>
            <span class="date-to">至 {{ item.end_time }}</span>
          </div>
        </div>
        <div class="residue">
          <span class="residue-label">剩余次数</span>
          <span class="num">{{ item.times - item.count }}</span><span class="residue-unit">次</span>
        </div>
        <div class="exam-actions">
          <router-link :to="'/text/' + item.id + '/' + typeIndex" class="exam-btn exam-btn-primary">去考试</router-link>
          <div class="exam-actions-sub">
            <button
              class="exam-btn exam-btn-secondary"
              :disabled="isBtnLocked('score', item.id)"
              @click="viewScoreBtn(item.id, item.exam_name)"
            >查看分数</button>
            <button
              class="exam-btn exam-btn-secondary"
              :disabled="isBtnLocked('record', item.id)"
              @click="viewExamRecordBtn(item.id, item.exam_name)"
            >查看试卷</button>
          </div>
        </div>
      </li>
      <li class="no-data" v-if="classExam && classExam.length == 0 && (classInfo && classInfo.id != '302')">
        班级内还没有考试
      </li>
    </ul>
    <div class="view-score" v-if="viewScore">
      <div class="score-content">
        <!-- <div class="close" @click="viewScore=false"></div> -->
        <div class="score-title">
          {{ viewScoreTitle }}
          <span class="close" @click="viewScore = false"></span>
        </div>
        <ul class="my-table">
          <li class="table-th">
            <span class="table-td" style="width: 58px">id</span>
            <span class="table-td" style="width: 170px">考试时间</span>
            <span class="table-td" style="width: 90px">分数</span>
          </li>
          <li class="table-tr" v-for="(item) in queryScore.list" :key="item.created_at">
            <span class="table-td" style="width: 58px">{{ item.id }}</span>
            <span class="table-td" style="width: 170px">{{item.created_at}}</span>
            <span class="table-td" style="width: 90px">{{queryScore.is_show_score==1 ? item.score : '--'}}</span>
            <p class="btn" v-if="queryScore.is_show_score==1" @click="examDetail(item)">查看</p>
          </li>
          <li class="table-tr nodata" v-if="queryScore.list.length == 0">
            <span class="table-td">暂无分数</span>
          </li>
        </ul>
      </div>
    </div>

    <!-- 查看试卷记录 -->
    <div class="record-modal" v-if="viewExamRecord" @click.self="viewExamRecord = false">
      <div class="record-sheet">
        <div class="sheet-handle"></div>
        <div class="sheet-header">
          <h3 class="sheet-title">{{ examRecordTitle }}</h3>
          <span class="sheet-close" @click="viewExamRecord = false"></span>
        </div>
        <p class="sheet-subtitle">考试记录 · 共 {{ examRecordData.list.total || examRecordList.length }} 条</p>
        <div class="record-list-wrap">
          <div class="record-list">
            <div
              class="record-item"
              v-for="item in examRecordList"
              :key="item.id"
              @click="examRecordDetail(item)"
            >
              <div class="record-left">
                <!-- <span class="record-id">记录 #{{ item.id }}</span> -->
                <span class="record-id">考试记录</span>
                <span class="record-time">{{ item.created_at }}</span>
              </div>
              <div class="record-right">
                <span
                  class="record-score"
                  :class="{ 'score-hidden': examRecordData.is_show_score != 1 }"
                >{{ examRecordData.is_show_score == 1 ? item.score + '分' : '--' }}</span>
                <span class="record-action">查看详情</span>
              </div>
            </div>
            <div class="record-empty" v-if="examRecordList.length === 0">
              <p class="empty-text">暂无考试记录</p>
            </div>
          </div>
        </div>
        <div class="exam-record-pagination" v-if="examRecordData.list && examRecordData.list.last_page > 1">
          <button class="page-btn" :disabled="examRecordPage <= 1" @click.stop="examRecordPageChange(examRecordPage - 1)">上一页</button>
          <span class="page-info">{{ examRecordPage }} / {{ examRecordData.list.last_page }}</span>
          <button class="page-btn" :disabled="examRecordPage >= examRecordData.list.last_page" @click.stop="examRecordPageChange(examRecordPage + 1)">下一页</button>
        </div>
      </div>
    </div>

    <!-- 证书图片下载弹框 -->
    <div class="mask_cont_box" v-if="bookImgState">
      <div class="cont_data">
        <p class="close" @click="bookImgState = false"><img src="@/assets/m/wrong-black.png" alt=""></p>
        <p class="tips">长按图片保存到手机</p>
        <p class="img">
          <img :src="classData.cert_url" alt="">
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import TopBar from "@/m/common/topBar.vue";
export default {
  name: "ClassInfo",
  data() {
    return {
      classInfo: "", //班级信息
      classSelect: "", //选中班级
      classCourse: null, //课程列表
      classExam: null, //考试列表
      viewScore: false, //查看分数弹窗
      viewScoreTitle: "", //弹窗标题
      // 分数数据结构：模板会读取 `queryScore.list.length` 等字段，
      // 所以需要保证至少有一个空数组，避免首次渲染/异步赋值时读取 undefined。
      queryScore: { list: [], is_show_score: 0 }, //分数数据
      viewExamRecord: false,
      examRecordTitle: '',
      examRecordExamId: null,
      examRecordPage: 1,
      examRecordData: { is_show_score: 0, list: { data: [], current_page: 1, total: 0, last_page: 1, per_page: 20 } },
      clickGuard: {},
      classData: "",
      typeIndex: '', //1班级  2开发式班级
      siteInfo: '',
      textCourseList: [],//文本课程列表
      classId: '',//班级id
      isWeixin: '',//判断是不是微信环境
      bookImgState: false,//证书图片弹框
    };
  },
  components: {
    TopBar,
  },
  computed: {
    examRecordList() {
      const list = this.examRecordData.list;
      return list && Array.isArray(list.data) ? list.data : [];
    },
  },
  mounted() {
    this.siteInfo = JSON.parse(localStorage.getItem('siteInfo')) ? JSON.parse(localStorage.getItem('siteInfo')) : '';
    this.classId = this.$route.params.id
    this.typeIndex = this.$route.params.type
    if (this.typeIndex == 2) {
      this.getTextCourseList()
    }

    this.getClassInfo();
    let ua = window.navigator.userAgent.toLowerCase();
    //判断是不是微信
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      // 微信
      this.isWeixin = true
    } else {
      this.isWeixin = false
    }
  },
  methods: {
    isBtnLocked(type, id) {
      return !!this.clickGuard[`${type}_${id}`];
    },
    guardClick(key, fn, cooldown = 500) {
      if (this.clickGuard[key]) return;
      this.$set(this.clickGuard, key, true);
      const release = () => {
        setTimeout(() => {
          this.$set(this.clickGuard, key, false);
        }, cooldown);
      };
      let ret;
      try {
        ret = fn();
      } catch (err) {
        release();
        throw err;
      }
      if (ret && typeof ret.finally === 'function') {
        ret.finally(release);
      } else {
        release();
      }
    },
    //获取班级列表
    getClassInfo() {
      let classId = this.classId
      let url = this.typeIndex == '1' ? '/v1/personal/classList' : '/v1/openClass/classList'
      this.$axios
        .post(url, {}, { useLog: true })
        .then((res) => {
          if (res.data.list.length > 0) {
            for (let i = 0; i < res.data.list.length; i++) {
              if (res.data.list[i].id == classId) {
                this.classInfo = res.data.list[i];
              }
            }
          }

          // this.getClassCourse(this.classInfo.id);
          this.getClassData(this.classInfo.id);
          // this.getClassExam(this.classInfo.id);
        });
    },
    // 获取文本课程
    getTextCourseList() {
      this.$axios.post(`/v1/openClass/classTextCourse`, { class_id: this.classId }, { useLog: true }).then(res => {
        if (res.code == 0) {
          this.textCourseList = res.data
        }
      })
    },
    // 文本课程-跳转到详情
    goTextDetail(id) {
      this.$router.push('/textCourse/detail?id=' + id)
    },
    // 获取班级下的信息
    getClassData(id) {
      let url = this.typeIndex == '1' ? '/v1/personal/myClass' : '/v1/openClass/myClass'

      this.$axios
        .post(
          url,
          {
            class_id: id,
          },
          { useLog: true }
        )
        .then((res) => {
          if (res.data.cert_url) {
            res.data.cert_url = res.data.cert_url.replace("http:", "https:");
          }
          this.classData = res.data;
          this.classCourse = res.data.courseList;
          this.classExam = res.data.examList;
        });
    },
    //获取班级课程
    getClassCourse(id) {
      let url = this.typeIndex == '1' ? '/v1/personal/myClass' : '/v1/openClass/myClass'

      this.$axios
        .post(
          `/v1/personal/classCourse`,
          {
            class_id: id,
          },
          { useLog: true }
        )
        .then((res) => {
          this.classCourse = res.data;
        });
    },
    //获取班级考试
    getClassExam(id) {
      let url = this.typeIndex == '1' ? '/v1/personal/classExam' : '/v1/openClass/classExam'

      this.$axios
        .post(
          url,
          {
            class_id: id,
          },
          { useLog: true }
        )
        .then((res) => {
          this.classExam = res.data;
        });
    },
    //查看分数
    viewScoreBtn(id, name) {
      this.guardClick(`score_${id}`, () => {
        let url = this.typeIndex == '1' ? '/v1/personal/queryScore' : '/v1/openClass/queryScore'

        return this.$axios
          .post(
            url,
            {
              exam_id: id,
            },
            { useLog: true }
          )
          .then((res) => {
            this.viewScoreTitle = name;
            const payload = res ? res.data : undefined;
            if (Array.isArray(payload)) {
              this.queryScore = {
                list: payload,
                is_show_score: 1,
              };
            } else {
              const data = payload && typeof payload === 'object' ? payload : {};
              this.queryScore = {
                list: Array.isArray(data.list) ? data.list : [],
                is_show_score: data.is_show_score != null ? data.is_show_score : 1,
                ...data,
              };
            }
            this.viewScore = true;
          });
      });
    },
    examDetail(row) {
      this.guardClick(`detail_${row.id}`, () => {
        this.$router.push('/userCenter/exam?id=' + row.id + '&type=' + this.typeIndex);
      }, 800);
    },
    viewExamRecordBtn(examId, name) {
      this.guardClick(`record_${examId}`, () => {
        this.examRecordExamId = examId;
        this.examRecordTitle = name;
        this.examRecordPage = 1;
        return this.fetchExamRecordList(1);
      });
    },
    fetchExamRecordList(page) {
      const url = this.typeIndex == '1'
        ? '/v1/personal/examRecordList'
        : '/v1/openClass/examRecordList';

      return this.$axios
        .post(
          url,
          {
            exam_id: this.examRecordExamId,
            per_page: 20,
            page: page,
          },
          { useLog: true }
        )
        .then((res) => {
          if (res.code == 0) {
            const data = res.data || {};
            const list = data.list && typeof data.list === 'object' ? data.list : {};
            this.examRecordData = {
              is_show_score: data.is_show_score != null ? data.is_show_score : 1,
              list: {
                data: Array.isArray(list.data) ? list.data : [],
                current_page: list.current_page || page,
                total: list.total || 0,
                last_page: list.last_page || 1,
                per_page: list.per_page || 20,
              },
            };
            this.examRecordPage = page;
            this.viewExamRecord = true;
          }
        });
    },
    examRecordPageChange(page) {
      const lastPage = this.examRecordData.list.last_page || 1;
      if (page < 1 || page > lastPage) return;
      this.guardClick(`record_page_${this.examRecordExamId}_${page}`, () => {
        return this.fetchExamRecordList(page);
      });
    },
    examRecordDetail(row) {
      this.guardClick(`record_detail_${row.id}`, () => {
        this.viewExamRecord = false;
        this.$router.push('/userCenter/exam?id=' + row.id + '&type=' + this.typeIndex);
      }, 800);
    },
  },
};
</script>

<style scoped lang="scss">
.class-title {
  padding: 28px;
  font-size: 28px;
  color: #333;
}

// .line {
//   width: 100%;
//   height: 10px;
//   background: #f5f5f5;
// }
.class_main {
  .class_cont {
    background: #fff;
    box-shadow: 0px 0px 30px 2px rgba(0, 0, 0, 0.08);

    .info_show {
      width: 100%;
      min-height: 276px;
      background: linear-gradient(90deg, #0065df 0%, #55a2ff 100%);
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .title_name {
        font-size: 30px;
        font-family: Source Han Sans CN-Bold, Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
        text-align: center;
        padding-top: 54px;
      }

      .deep_pros {
        padding: 36px;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;

        div.left {
          p.label {
            font-size: 24px;
            font-family: Source Han Sans CN-Normal, Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
          }

          .pross_fir {
            margin-top: 16px;
            position: relative;
            width: 333px;
            height: 16px;
            background: #eeeeee;
            border-radius: 124px 124px 124px 124px;

            p {
              position: absolute;
              left: 0;
              top: 0;
              background: #eda220;
              border-radius: 124px 124px 124px 124px;
              height: 100%;
            }
          }
        }

        div.right {
          padding-top: 10px;
          font-size: 24px;
          font-family: Source Han Sans CN-Normal, Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
        }
      }

      // 证书下载
      .cert_cont {
        padding: 0 36px 36px;

        a {
          color: #fff;
          font-size: 25px;
          // border: 1px solid #999;
          padding: 15px 25px;
          border-radius: 5px;
          background: orange;
        }
      }
    }

    .exam_info {
      display: flex;
      padding: 16px 36px;
      justify-content: space-between;

      p.text {
        font-size: 24px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #999999;
      }

      div.right_text {
        display: flex;
        align-items: center;

        p {
          font-size: 24px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #579f33;
        }

        p.text2 {
          color: #e15416;
          margin-left: 25px;
        }
      }
    }
  }
}

.title {
  width: 100%;
  line-height: 44px;
  font-size: 32px;
  margin-bottom: 28px;
}

.class-list {
  margin-top: 20px;
}

.class-list,
.test-list {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0 28px;

  &::after {
    content: "";
    display: block;
    width: 28%;
  }
}

.class-list-info {
  width: 335px;
  box-shadow: 0px 0px 12px 0px rgba(0, 12, 40, 0.14);
  border-radius: 8px;
  margin-bottom: 24px;

  .info-img {
    width: 100%;
    height: 186px;
  }

  .info-content {
    padding: 9px 16px 24px 20px;
  }

  .info-title {
    height: 70px;
    font-size: 28px;
    color: #333;
    line-height: 35px;
  }

  .progress {
    padding-top: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .num {
      font-size: 24px;
      color: #000;
      text-shadow: 0px 0px 50px rgba(0, 0, 0, 0.3);
    }

    .progress-bg,
    .progress-line {
      width: 230px;
      height: 7px;
      background: #e5e5e5;
      box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.3);
      border-radius: 3px;
    }

    .progress-line {
      background: #254ed4;
    }
  }
}

.test-info {
  box-sizing: border-box;
  width: 100%;
  padding: 28px;
  box-shadow: 0 2px 16px rgba(0, 12, 40, 0.08);
  border-radius: 12px;
  margin-bottom: 28px;
  background: #fff;

  .exam-card-head {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 16px;
  }

  .exam-badge {
    align-self: flex-start;
    font-size: 20px;
    color: #254ed4;
    background: #eef2ff;
    padding: 4px 14px;
    border-radius: 6px;
  }

  .test-title {
    width: 100%;
    max-height: 70px;
    font-size: 28px;
    font-weight: 600;
    color: #1a1a2e;
    line-height: 35px;
  }

  .test-date {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 16px 20px;
    background: #f7f8fa;
    border-radius: 8px;
    margin-bottom: 16px;

    &::before {
      content: '';
      flex-shrink: 0;
      width: 28px;
      height: 28px;
      margin-top: 2px;
      background: url(~@/assets/clock-ico.png) no-repeat center;
      background-size: contain;
    }

    .test-date-text {
      flex: 1;
      min-width: 0;
      font-size: 22px;
      color: #888;
      line-height: 1.5;

      span {
        display: block;
        word-break: break-all;
      }

      .date-to {
        margin-top: 4px;
        color: #aaa;
      }
    }
  }

  .residue {
    display: flex;
    align-items: baseline;
    gap: 6px;
    font-size: 22px;
    color: #999;
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #f0f2f5;

    .residue-label {
      color: #bbb;
    }

    .num {
      font-size: 36px;
      font-weight: 600;
      color: #254ed4;
      line-height: 1;
    }

    .residue-unit {
      color: #999;
    }
  }

  .exam-actions {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .exam-btn {
      box-sizing: border-box;
      display: block;
      border: none;
      cursor: pointer;
      text-decoration: none;
      text-align: center;
      border-radius: 8px;
      font-size: 26px;

      &:disabled {
        opacity: 0.5;
      }
    }

    .exam-btn-primary {
      width: 100%;
      height: 72px;
      line-height: 72px;
      background: #254ed4;
      color: #fff;
      font-weight: 500;
    }

    .exam-actions-sub {
      display: flex;
      gap: 16px;
    }

    .exam-btn-secondary {
      flex: 1;
      height: 64px;
      line-height: 64px;
      background: #fff;
      color: #666;
      border: 1px solid #e8eaf0;
      font-size: 24px;
      min-width: 0;
    }
  }
}

.view-score {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);

  .score-content {
    box-sizing: border-box;
    width: 100%;
    max-height: 600px;
    padding: 30px;
    background-color: #fff;
    position: absolute;
    left: 0;
    bottom: 0;

    .score-title {
      font-size: 32px;
      color: #333;
      margin-bottom: 60px;
      position: relative;

      .close {
        display: block;
        width: 50px;
        height: 50px;
        background: url(~@/assets/close-grey-ico.png) no-repeat center center;
        background-size: auto 23px;
        position: absolute;
        top: 0;
        right: 0;
      }
    }

    .close {
      width: 30px;
      height: 30px;
      background: url(~@/assets/close-ico.png) no-repeat;
      background-size: 100%;
      position: absolute;
      right: -50px;
      top: 0;
      cursor: pointer;
    }
  }
}

.my-table {
  box-sizing: border-box;
  max-height: 352px;
  overflow-y: auto;
  border-radius: 6px;

  .table-th,
  .table-tr {
    height: 88px;

    &.nodata {
      width: 100%;
      justify-content: center;
    }

    .table-td {
      font-size: 26px;
    }

    p.btn {
      color: #0065df;
    }
  }

  .table-th {
    position: -webkit-sticky;
    position: -moz-sticky;
    position: -ms-sticky;
    position: sticky;
    top: 0;
  }
}

.exam-record-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  flex-shrink: 0;
  padding-top: 24px;
  margin-top: 16px;
  border-top: 1px solid #f0f2f5;

  .page-info {
    font-size: 24px;
    color: #666;
  }

  .page-btn {
    padding: 0 28px;
    height: 60px;
    line-height: 60px;
    font-size: 24px;
    color: #254ed4;
    background: #eef2ff;
    border: none;
    border-radius: 30px;

    &:disabled {
      opacity: 0.4;
      color: #999;
      background: #f5f5f5;
    }
  }
}

/* 查看试卷记录弹层 */
.record-modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 999;
  display: flex;
  align-items: flex-end;
}

.record-sheet {
  box-sizing: border-box;
  width: 100%;
  min-height: 72vh;
  max-height: 88vh;
  background: #fff;
  border-radius: 28px 28px 0 0;
  padding: 0 28px calc(28px + env(safe-area-inset-bottom));
  display: flex;
  flex-direction: column;
  animation: sheetUp 0.28s ease-out;
}

@keyframes sheetUp {
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
}

.sheet-handle {
  width: 64px;
  height: 8px;
  background: #e0e0e0;
  border-radius: 4px;
  margin: 16px auto 24px;
  flex-shrink: 0;
}

.sheet-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  margin-bottom: 8px;
}

.sheet-title {
  flex: 1;
  font-size: 34px;
  font-weight: 600;
  color: #1a1a2e;
  margin: 0;
  padding-right: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sheet-close {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  background: url(~@/assets/close-grey-ico.png) no-repeat center center;
  background-size: 24px;
}

.sheet-subtitle {
  font-size: 24px;
  color: #999;
  margin: 0 0 24px;
  flex-shrink: 0;
}

.record-list-wrap {
  flex: 1;
  min-height: 0;
  max-height: calc(88vh - 320px);
  border: 1px solid #eef0f3;
  border-radius: 16px;
  background: #fafbfc;
  overflow: hidden;
}

.record-list {
  height: 100%;
  max-height: calc(88vh - 320px);
  overflow-x: hidden;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  padding: 12px 8px 12px 12px;
  box-sizing: border-box;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background: #eef0f3;
    border-radius: 5px;
    margin: 8px 0;
  }

  &::-webkit-scrollbar-thumb {
    background: #b0b8c8;
    border-radius: 5px;
    border: 2px solid #eef0f3;

    &:hover {
      background: #254ed4;
    }
  }

  scrollbar-width: thin;
  scrollbar-color: #b0b8c8 #eef0f3;
}

.record-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 24px 20px;
  margin-bottom: 16px;
  background: #f7f8fa;
  border-radius: 16px;
  border: 1px solid #eef0f3;
  transition: background 0.15s;

  &:active {
    background: #eef2ff;
    border-color: #c7d4f7;
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.record-left {
  flex: 1;
  min-width: 0;
}

.record-id {
  display: block;
  font-size: 26px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.record-time {
  display: block;
  font-size: 22px;
  color: #999;
  word-break: break-all;
  line-height: 1.4;
}

.record-right {
  flex-shrink: 0;
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.record-score {
  font-size: 32px;
  font-weight: 700;
  color: #254ed4;
  line-height: 1;

  &.score-hidden {
    font-size: 28px;
    color: #bbb;
    font-weight: 500;
  }
}

.record-action {
  font-size: 22px;
  color: #254ed4;
  padding: 6px 16px;
  background: #eef2ff;
  border-radius: 20px;
}

.record-empty {
  text-align: center;
  padding: 100px 0 80px;

  .empty-text {
    font-size: 28px;
    color: #bbb;
    margin: 0;
  }
}

.no-data {
  width: 100%;
  text-align: center;
  color: #999;
}

.mask_cont_box {
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.3);
  width: 100%;
  height: 100%;

  .cont_data {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    // height: 80vh;
    background: #fff;
    border-radius: 10px;
    padding-bottom: 10px;

    p.close {
      display: flex;
      justify-content: flex-end;
      margin: 15px;

      img {
        width: 40px;
        height: 40px;
      }
    }

    p.tips {
      text-align: center;
      font-size: 28px;
    }

    p.img {
      width: 95%;
      margin: 0 auto;

      img {
        height: auto;
        width: 100%;
      }
    }
  }
}
</style>
